export default __webpack_public_path__ + "static/media/2020-3.bcac5b96.jpeg";